module.exports = __webpack_public_path__ + "static/media/office-geotiller.f76d5158.svg";